import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/overlay';
import { inject, Injectable, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';

export interface AppDialogConfig<D = unknown> {
  data?: D;
  width?: string | number;
  height?: string | number;
  minWidth?: string | number;
  minHeight?: string | number;
  maxWidth?: string | number;
  maxHeight?: string | number;
  disableClose?: boolean;
  hasBackdrop?: boolean;
  backdropClass?: string | string[];
  panelClass?: string | string[];
  autoFocus?: string;
  ariaLabel?: string;
  role?: 'dialog' | 'alertdialog';
}


export class AppDialogRef<R = any> {
  constructor(private readonly ref: DialogRef<R>) {}

  afterClosed(): Observable<R | undefined> {
    return this.ref.closed;
  }

  close(result?: R): void {
    this.ref.close(result);
  }

  get backdropClick(): Observable<MouseEvent> {
    return this.ref.backdropClick;
  }
}

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private readonly dialog = inject(Dialog);

  open<R = any, D = unknown>(
    componentOrTemplate: ComponentType<unknown> | TemplateRef<unknown>,
    config: AppDialogConfig<D> = {}
  ): AppDialogRef<R> {
    const extra = config.panelClass;
    const panelClass = extra ? ['app-dialog-panel', ...(Array.isArray(extra) ? extra : [extra])] : 'app-dialog-panel';

    const ref = this.dialog.open<R>(
      componentOrTemplate as ComponentType<unknown>,
      {
        ...config,
        panelClass,
      } as never
    );

    return new AppDialogRef<R>(ref);
  }

  closeAll(): void {
    this.dialog.closeAll();
  }
}
